'use strict';

const awesompleteInputs = document.querySelectorAll('.js-awesomplete');

/**
 *
 *
 *
 */
const init = function () {

	if (awesompleteInputs) {
		setupAwesomplete();
	}

};


/**
 *
 *
 */
const setupAwesomplete = function () {

	Array.prototype.forEach.call(awesompleteInputs, awesompleteInput => {

		const form = awesompleteInput.parentNode;
		const hiddenFieldName = form.getAttribute('data-hidden-field-name');
		let hiddenField = null;

		if (hiddenFieldName) {
			hiddenField = document.createElement('input');
			hiddenField.classList.add('search-auto-complete__hidden');
			hiddenField.setAttribute('type', 'hidden');
			hiddenField.setAttribute('name', hiddenFieldName);
			form.insertBefore(hiddenField, awesompleteInput);
		}

		new Awesomplete(awesompleteInput, {
			replace: function (suggestion) {
				this.input.value = suggestion.label;

				if (hiddenField !== null) {
					hiddenField.value = suggestion.value;
				}
			}
		});

		awesompleteInput.addEventListener('awesomplete-selectcomplete', () => {
			form.submit();
		});

	});

};

const api = {
	init: init
};

export default api;